export default __webpack_public_path__ + "static/media/hamburger-full-width.8dd79769.svg";